import { BLAdmin } from '@/types/profile.types';
import { Post } from '../helpers';

const AddAdmin = (email: string, permissions: string[], isSSO: boolean): Promise<BLAdmin> => {
  return Post({ url: `/v3/admin/auth/add-admin`, body: { email, permissions, isSSO } });
};

export default AddAdmin;
